import React, { ReactElement, useMemo } from 'react';

// Components
import TagsSearchBar from './components/TagsSearchBar';
import TagsCreateButtons from './components/TagsCreateButtons';
import TagsList from './components/TagsList';

// Utils
import { TagsToolbarPopupProps } from './popup/TagsToolbarPopup';
import useTagContentState from './useTagContentState';

// Types
import { UseTagPopupsStateReturn } from './useTagPopupsState';

import './TagsToolContent.scss';

export type TagsToolContentProps = TagsToolbarPopupProps & UseTagPopupsStateReturn;

const TagsToolContent = (props: TagsToolContentProps): ReactElement => {
    const { handleClickEdit, shareRootPath } = props;

    const {
        searchString,
        setSearchString,
        selectedTags,
        unselectedTags,
        handleClickSelectedTag,
        handleAddTagToElement,
        handleCreateTag,
    } = useTagContentState(props);

    const showCreateButtons = useMemo(
        () => searchString && ![...selectedTags, ...unselectedTags].some((tag) => tag.name === searchString),
        [searchString, selectedTags, unselectedTags],
    );
    return (
        <div className="TagsToolContent">
            <TagsSearchBar value={searchString} onChange={setSearchString} handleCreateTag={handleCreateTag} />
            <TagsList
                tagsArray={selectedTags}
                handleClickTag={handleClickSelectedTag}
                handleClickEdit={handleClickEdit}
                isSelected
            />
            <TagsList
                tagsArray={unselectedTags}
                handleClickTag={handleAddTagToElement}
                handleClickEdit={handleClickEdit}
            />
            {showCreateButtons && <TagsCreateButtons handleCreateTag={handleCreateTag} shareRootPath={shareRootPath} />}
        </div>
    );
};

export default TagsToolContent;
